import React from 'react';
import PropTypes from 'prop-types';
import { useReactiveVar } from '@apollo/client';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FingoMainView from '../../../../components/layout/FingoMainView';
import { FingoDataGrid } from '../../../../components/dataGrids';
import {
  offerSelectedClientsVar,
  shoppingCartOffersVar,
} from '../../../../apollo/reactive-variables/shopping-cart';
import useIsMobile from '../../../../hooks/useIsMobile';
import {
  OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL,
  DETAILED_DATA_GRID_CLASS_NAME,
} from '../../../../theme/constants/data-grid';
import CLIENT_OFFERS_SUMMARY from '../../../../graphql/queries/factoring/client-offers-summary';

const AvailableOffersSummaryDetails = ({
  row,
  getColumns,
  detailsHeaders,
  detailsMobileHeaders,
}) => {
  const isMobile = useIsMobile('tablet');
  const offerSelectedClients = useReactiveVar(offerSelectedClientsVar);
  const shoppingCartOffers = useReactiveVar(shoppingCartOffersVar);
  const offersForClient = offerSelectedClients[row.id] || [];
  const handleDelete = (invoiceId) => {
    const newSelectedIds = offersForClient.filter((id) => id !== invoiceId);
    const newShoppingCartOffers = shoppingCartOffers.filter(
      (offer) => offer.invoiceId !== invoiceId,
    );
    offerSelectedClientsVar({ ...offerSelectedClients, [row.id]: newSelectedIds });
    shoppingCartOffersVar(newShoppingCartOffers);
  };
  const columns = getColumns(isMobile, handleDelete);
  return (
    <Stack sx={{ height: 'auto' }}>
      <FingoMainView
        id="available-offers-details"
        hideReloadButton
        query={CLIENT_OFFERS_SUMMARY}
        queryCustomVariables={{
          receiverId: row.id,
          id_In: offersForClient,
        }}
        queryFetchPolicy="cache-first"
        slots={{
          table: FingoDataGrid,
        }}
        slotProps={{
          table: {
            includeHeaders: detailsHeaders,
            mobileHeaders: detailsMobileHeaders,
            rowHeight: 65,
            columns,
            initialOrderBy: 'expirationDate',
            dataGridClassName: DETAILED_DATA_GRID_CLASS_NAME,
            noRowsMessage: () => <Typography>Sin facturas</Typography>,
            rowsPerPageOptions: [10],
            disableSelectionOnClick: true,
            checkboxSelection: false,
            outsideBoxProps: isMobile ? OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL : {},
          },
        }}
      />
    </Stack>
  );
};

AvailableOffersSummaryDetails.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  getColumns: PropTypes.func.isRequired,
  detailsHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
  detailsMobileHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AvailableOffersSummaryDetails;
